/** @jsx jsx */
import { P, TextBlock } from "@cd2/text/build/es6"
import { css, jsx } from "@emotion/core"

import React from "react"

interface IProps {
  children: React.ReactNode
  description?: React.ReactNode
  checkbox?: boolean
  className?: string
  bordered?: boolean
}

export function FieldWithDescription({
  children,
  description,
  checkbox,
  className,
  bordered,
}: IProps) {
  return (
    <div
      css={css`
        display: ${checkbox ? "block" : "flex"};
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 2px;

        ${bordered &&
        css`
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          padding: 6px 10px;
        `}
      `}
      className={className}
    >
      <div
        css={css`
          flex: 4 4 300px;
        `}
      >
        {children}
      </div>
      {description && (
        <div
          css={css`
            flex: 1 1 200px;
            ${checkbox &&
            css`
              margin-left: 20px;
            `}
          `}
        >
          <TextBlock size="small" color="#999">
            {typeof description === "string" ? <P>{description}</P> : description}
          </TextBlock>
        </div>
      )}
    </div>
  )
}
